import cn from 'classnames';
import Image from 'next/image';
import React from 'react';
import Cookies from 'universal-cookie';

import s from './index.module.less';

interface BestDealLabelProps {
  className?: string;
}

const BestDealLabel = ({ className = '' }: BestDealLabelProps) => {
  const cookie = new Cookies();
  const language = cookie.get('language')?.language;
  const isKhmer = typeof language === 'string' && language !== 'vietnamese';

  return (
    <div className={cn(s.bestDealLabel, className)}>
      <Image
        src={isKhmer ? '/images/best-deal-khmer.png' : '/images/best-deal-label.svg'}
        layout="fill"
        objectFit="contain"
      />
    </div>
  );
};

export default BestDealLabel;
